import { render, staticRenderFns } from "./ctrlobs3.vue?vue&type=template&id=d7de83c6"
import script from "./ctrlobs3.vue?vue&type=script&lang=js"
export * from "./ctrlobs3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports